import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
import {
  getInitFormData,
  applySlip,
  setConfigToColumns,
} from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global, useMenuStore } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import SnGrid from "@shared/components/GridV2/SnGrid"; // 공통 그리드
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface
import { showResizablePopupModal } from "@widgets/CommonModal";
import SnButton from "@shared/components/SnButton";
import SN_PRD_WMO_REG_003_POP_01 from "./SN_PRD_WMO_REG_003_POP_01";
import SnResizeBar from "@shared/components/SnResizeBar";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import { openAddInfoPopup } from "@widgets/commonpopup/sys/openAddInfoPopup";
import { openAddInfoRegPopup } from "@widgets/commonpopup/sys/openAddInfoRegPopup";
import {
  buildJsAddinfoFromFlags,
  extractAddInfoFlags,
  hydrateRowsWithAddInfo,
  parseJsAddinfoObject,
} from "@shared/utils/AddInfoUtils";
interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_PRD_WMO_REG_003 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
  });
  const [headerInfo, setHeaderInfo] = useState<any>({
    grid1: {},
    grid2: {},
  });
  const searchRef = useRef<any>(null);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const { userInfo } = global(); // Login user 정보
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [selectedDocu, setSelectedDocu] = useState<string>("");
  const [addInfoFlags, setAddInfoFlags] = useState<string[]>([]);
  const [addInfoFlags2, setAddInfoFlags2] = useState<string[]>([]);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({});
        setFormControlData(rtn.formControlData); // 조회조건 항목 설정
        setFormData(rtn.formData); // 조회조건 초기값
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  const onSearch = async (searchData: any) => {
    const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
    const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }
    try {
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      const params = {
        id: "sn_prd_wmo_reg_003_01",
        params: searchRef.current.getFormdata(),
      };
      const data: any = await fnGetDataSet(params);

      const flags =
        addInfoFlags.length > 0
          ? addInfoFlags
          : await loadAddInfoFlags("grid1", setAddInfoFlags);

      const flags2 =
        addInfoFlags2.length > 0
          ? addInfoFlags2
          : await loadAddInfoFlags("grid2", setAddInfoFlags2);

      setDataSources({
        grid1: hydrateRowsWithAddInfo(data[0] || [], flags),
        grid2: hydrateRowsWithAddInfo(data[1] || [], flags2),
      });
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onInsert = async () => {
    try {
      const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
      if (modifiedRowsH.modifiedRowcount > 0) {
        showDialog("warning", "수정된 내용이 있습니다.");
        return;
      }
      const searchInfo = searchRef.current.getFormdata();
      const newRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: searchInfo.cd_biz,
        cd_dept: userInfo.cd_dept,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        dt_woreq: todayform,
        cd_gp: userInfo.cd_gp,
        nm_gp: userInfo.nm_gp,
        no_woreq: "",
        st_woreq: "P",
      };
      gridRefs.current["grid1"].current.addRow(newRow);
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onDelete = async () => {
    if (gridRefs.current["grid1"].current?.getDisplayedRowCount() < 1) return;

    const confirm = await showDialog("confirm", "삭제하시겠습니까?");
    if (!confirm) return;

    gridRefs.current["grid2"].current.deleteAllRows();
    gridRefs.current["grid1"].current.deleteSelectedRows();

    const realDeletedRows =
      gridRefs.current["grid1"].current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      // 실제로 삭제된 행이 없으면 변경 사항을 적용하고 반환합니다.
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      return;
    }
    await onSave();
  };

  const onAddRow = () => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedNodeH == null) {
        alert("선택된 행이 없습니다.");
        return false;
      }

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return false;
      }
      const maxNoLine =
        gridRefs.current["grid2"].current.getMaxValue("no_line");
      const newRow = {
        cd_firm: userInfo.cd_firm,
        no_woreq: focusedNodeH.data.no_woreq,
        dt_dlv: focusedNodeH.data.dt_woreq,
        no_line: maxNoLine + 1,
        no_line_so: 0,
        qt_woreq: 0,
        qt_wo: 0,
        qt_so: 0,
        st_woreq: "P",
      };
      return gridRefs.current["grid2"].current?.addRow(newRow);
    } catch (error: any) {}
  };

  const onDeleteRow = async () => {
    if (gridRefs.current["grid2"].current?.getDisplayedRowCount() < 1) return;

    gridRefs.current["grid2"].current?.deleteSelectedRows();
  };

  const onSave = async () => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      gridRefs.current["grid2"].current?.stopEditing();
      // H 필수값 체크
      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }

      // L 필수값 체크
      const requiredValuesCheckL =
        gridRefs.current["grid2"].current.requiredValuesCheck();
      if (!requiredValuesCheckL) {
        return;
      }

      const prdwmohChange = gridRefs.current["grid1"].current.getChange();
      const prdwmolChange = gridRefs.current["grid2"].current.getChange();

      if (
        prdwmohChange.modifiedRowcount === 0 &&
        prdwmolChange.modifiedRowcount === 0
      ) {
        showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      const focusedRowNodeH =
        gridRefs.current["grid1"].current.focusedRowNode();
      const noSlip = await applySlip({
        cd_column: "no_woreq",
        cd_module: "PRD",
        no_line: 1,
        cd_prefix: "WMO",
        dt: focusedRowNodeH.data.dt_woreq,
        girdrefs: [gridRefs.current["grid1"], gridRefs.current["grid2"]],
        inserts: [prdwmohChange, prdwmolChange],
        cd_menu: Menuprops.cd_menu,
      });

      const flagsForSave =
        addInfoFlags.length > 0
          ? addInfoFlags
          : await loadAddInfoFlags("grid1", setAddInfoFlags);

      const prdwmohWithAddInfo = {
        ...prdwmohChange,
        insert: (prdwmohChange.insert ?? []).map((row: any) => ({
          ...row,
          js_addinfo: buildJsAddinfoFromFlags(row, flagsForSave),
        })),
        update: (prdwmohChange.update ?? []).map((row: any) => ({
          ...row,
          js_addinfo: buildJsAddinfoFromFlags(row, flagsForSave),
        })),
      };

      const flagsForSave2 =
        addInfoFlags2.length > 0
          ? addInfoFlags2
          : await loadAddInfoFlags("grid2", setAddInfoFlags2);

      const prdwmolWithAddInfo = {
        ...prdwmolChange,
        insert: (prdwmolChange.insert ?? []).map((row: any) => ({
          ...row,
          js_addinfo: buildJsAddinfoFromFlags(row, flagsForSave2),
        })),
        update: (prdwmolChange.update ?? []).map((row: any) => ({
          ...row,
          js_addinfo: buildJsAddinfoFromFlags(row, flagsForSave2),
        })),
      };

      const SaveData = {
        prd_woreqh: prdwmohWithAddInfo,
        prd_woreql: prdwmolWithAddInfo,
      };

      const ok = await fnSave("SN_PRD_WMO_REG_003_SAVE_01", SaveData);
      if (!ok) return false;

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      setIsVisible(false);
      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate(true);
      gridRefs.current["grid2"].current.resetUpdate(true);
      return false;
    }
  };
  //#endregion

  //#region  Event Method
  const onGrid2BtnsClick = async (id: string) => {
    if (id === "addRow") {
      onAddRow();
    }

    if (id === "deleteRow") {
      onDeleteRow();
    }

    if (id === "btnMerge") {
      const grid2Ref = gridRefs.current["grid2"].current;
      const checkedRows: any[] = grid2Ref?.getCheckedRows?.() || [];

      if (checkedRows.length < 1) {
        await showDialog("alter", "체크된 행이 없습니다.");
        return;
      }

      const extractAddInfo = (row: any) =>
        Object.fromEntries(
          Object.entries(row).filter(([key]) => /^a\d+_/.test(key))
        );

      const mergedMap = new Map<string, any>();

      checkedRows.forEach((row: any) => {
        const key = row?.cd_item ?? "";

        if (!mergedMap.has(key)) {
          mergedMap.set(key, {
            ...row,
            qt_woreq: Number(row?.qt_woreq ?? 0) || 0,
            qt_so: Number(row?.qt_so ?? 0) || 0,
            js_addinfo: [extractAddInfo(row)],
          });
          return;
        }

        const prev = mergedMap.get(key);

        prev.qt_so =
          (Number(prev?.qt_so ?? 0) || 0) + (Number(row?.qt_so ?? 0) || 0);

        prev.qt_woreq =
          (Number(prev?.qt_woreq ?? 0) || 0) +
          (Number(row?.qt_woreq ?? 0) || 0);

        prev.js_addinfo.push(extractAddInfo(row));

        mergedMap.set(key, prev);
      });

      const deleteNodes: any[] = [];

      const checkedNodeIds = new Set(
        checkedRows.map((row: any) => row.KeyField)
      );

      grid2Ref?.forEachNode?.((node: any) => {
        if (checkedNodeIds.has(node.data.KeyField)) {
          deleteNodes.push(node);
        }
      });

      deleteNodes.forEach((node) => {
        grid2Ref?.deleteRowByNode?.(node);
      });

      const mergedRows = Array.from(mergedMap.values());

      mergedRows.forEach((row: any) => {
        const addedNode = onAddRow();
        if (!addedNode) return;

        addedNode.setDataValue("cd_item", row?.cd_item ?? "");
        addedNode.setDataValue("dc_item_spec", row?.dc_item_spec ?? "");
        addedNode.setDataValue("dc_item_unit", row?.dc_item_unit ?? "");
        addedNode.setDataValue("dt_dlv", row?.dt_dlv ?? "");
        addedNode.setDataValue("qt_woreq", Number(row?.qt_woreq ?? 0) || 0);
        addedNode.setDataValue("qt_wo", Number(row?.qt_wo ?? 0) || 0);
        addedNode.setDataValue("nm_cust", row?.nm_cust ?? "");
        addedNode.setDataValue("nm_cust_dlv", row?.nm_cust_dlv ?? "");
        addedNode.setDataValue("dt_isu_plan", row?.dt_isu_plan ?? "");
        addedNode.setDataValue("cd_pjt", row?.cd_pjt ?? "");
        addedNode.setDataValue("nm_pjt", row?.nm_pjt ?? "");
        addedNode.setDataValue("dc_rmk", row?.dc_rmk ?? "");
        addedNode.setDataValue("no_so", row?.no_so ?? "");
        addedNode.setDataValue("no_line_so", row?.no_line_so ?? 0);
        addedNode.setDataValue("qt_so", Number(row?.qt_so ?? 0) || 0);
        addedNode.setDataValue("fixCheckbox", false, "noEvent");

        const firstAddInfo = row.js_addinfo?.[0] ?? {};

        Object.entries(firstAddInfo).forEach(([key, value]) => {
          addedNode.setDataValue(key, value);
        });

        addedNode.setDataValue("js_addinfo", JSON.stringify(row.js_addinfo));
      });

      grid2Ref?.clearCheckBox?.();
    }
  };

  const Grid1btnclick = async (id: string) => {
    if (id === "aButtonApply") {
      const purPohChanges =
        gridRefs.current["grid1"].current.getChange().insert;
      if (purPohChanges.length === 0) {
        await showDialog("alter", "신규행을 추가하시기 바랍니다.");
        return;
      }
      const selectedFormData = searchRef.current.getFormdata();
      const selectedData = {
        cd_biz: selectedFormData.cd_biz,
        cd_cust: selectedFormData.cd_cust,
        dt_from: selectedFormData.dt_from,
        dt_to: selectedFormData.dt_to,
      };

      const component = <SN_PRD_WMO_REG_003_POP_01 />;
      const result = await showResizablePopupModal({
        title: "수주적용",
        children: component,
      });
      if (!result || result === "close") return;
      const Result: any = result[0];
      const focusedRowNodeH =
        gridRefs.current["grid1"].current.focusedRowNode();

      // 견적도움창 Line 결과 적용
      if (focusedRowNodeH && Result[0]) {
        for (const key in Result[0]) {
          focusedRowNodeH.setDataValue(key, Result[0][key]);
        }
        focusedRowNodeH.setDataValue("dt_woreq", todayform);
        focusedRowNodeH.setDataValue(
          "nm_st_woreq",
          Result[0]?.nm_pjt?.trim() || "계획"
        );
        focusedRowNodeH.setDataValue("dt_woreq", todayform);
      }
      Result.map((result: any) => {
        if (Result[0]) {
          const addedNode = onAddRow();
          if (addedNode) {
            for (const key in result) {
              if (key === "js_addinfo_h") continue;
              addedNode.setDataValue(key, result[key]);
            }
            addedNode.setDataValue("qt_so", result["qt"]);
            addedNode.setDataValue("qt_woreq", result["qt_app"]);
            addedNode.setDataValue("no_line_so", result["no_line"]);
            addedNode.setDataValue(
              "js_addinfo",
              result?.js_addinfo_h ?? result?.js_addinfo ?? ""
            );
            addedNode.setDataValue("fixCheckbox", false, "noEvent");
          }
        }
      });
      gridRefs.current["grid2"].current?.clearCheckBox?.();
    }
  };

  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event; // 클릭한 행 데이터
    if (selectedRow) {
      // 배열로 만들어서 필터링 함수 호출
      const no_woreq = selectedRow.no_woreq;
      setSelectedDocu(no_woreq);
      if (selectedRow.state == "insert") {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    } else {
      return;
    }
  };

  const handleContextMenu = (params: any) => {
    // SnGrid에서 onContextMenu는 객체({ id, menu }) 형태로 전달됨
    switch (params?.id) {
      case "wf_sn_prd_wmo_info":
        (async () => {
          const rowNode = gridRefs.current["grid2"].current.focusedRowNode();
          if (!rowNode) {
            await showDialog("alter", "선택된 행이 없습니다.");
            return;
          }
          if (!Menuprops.cd_menu) {
            await showDialog("alter", "메뉴 코드가 없습니다.");
            return;
          }

          // id_target은 호출 메뉴에서 전달 (고정값 아님)
          const idTarget = "grid2";

          const result = await openAddInfoRegPopup({
            title: "작업의뢰부가항목",
            cd_menu: Menuprops.cd_menu,
            id_target: idTarget,
            rowData: { ...rowNode.data },
            width: "980px",
            height: "760px",
            rememberSizeKey: "SN_PRD_WMO_REG_003",
          });
          if (!result || result === "close") return;

          const values = result?.values ?? {};
          Object.keys(values).forEach((key) => {
            rowNode.setDataValue(key, values[key]);
          });
        })();
        break;
      default:
    }
  };

  const onGrid2ExtraHeaderMenuClick = async (event: {
    id: string;
    params: any;
  }) => {
    if (event.id === "extra_item_setting") {
      await onOpenAddInfoPopup("grid2");
    }
  };

  const onOpenAddInfoPopup = async (idTarget = "grid2") => {
    // id_target에 해당하는 현재 컬럼 메타를 설정 팝업으로 전달한다.
    const columnInfos =
      idTarget === "grid2" ? columns.grid2 || [] : columns.grid1 || [];
    const saved = await openAddInfoPopup({
      cd_menu: Menuprops.cd_menu!,
      id_target: idTarget,
      columnInfos,
    });

    if (saved) {
      const rtn: any = await getInitFormData();
      setFormControlData(rtn.formControlData);
      setFormData((prev: any) => ({
        ...(rtn.formData || {}),
        ...(prev || {}),
      }));
      setColums({
        grid1: rtn.grid.grid1,
        grid2: rtn.grid.grid2,
      });

      // 부가항목 설정이 바뀌었을 수 있으므로 컬럼 설정과 flag 목록을 다시 동기화한다.
      await loadAddInfoFlags(idTarget);
      await onSearch(searchRef.current?.getFormdata?.());
    }
  };

  const loadAddInfoFlags = async (
    idTarget = "grid2",
    setFlags = setAddInfoFlags
  ) => {
    const result: any = await fnGetDataSet({
      id: "sys_addinfo_pop_01_01",
      params: {
        cd_firm: userInfo?.cd_firm ?? "",
        cd_menu: Menuprops?.cd_menu ?? "",
        id_target: idTarget,
      },
    });
    const rows = result?.[0] || [];
    const flags = extractAddInfoFlags(rows);
    setFlags(flags);
    return flags;
  };
  //#endregion

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onBtnAddClick: onGrid2BtnsClick,
          onBtnDeleteClick: onGrid2BtnsClick,
          onContextMenu: handleContextMenu,
          onExtraHeaderMenuClick: onGrid2ExtraHeaderMenuClick,
        },
      },
    }),
    [columns, dataSources]
  );

  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]} // Grid Name
            columnConfig={grids.grid1.columns} // 컬럼 설정 전달
            rowData={grids.grid1.dataSource} // Datasource
            etcProps={{ rowSelection: "single", title: "의뢰정보" }}
            events={grids.grid1.events}
            filter={{
              refs: [gridRefs.current["grid2"]],
              columns: ["no_woreq"],
            }}
            header={
              <div className="relative flex space-x-3">
                <SnButton
                  text="수주적용"
                  onClick={() => {
                    Grid1btnclick("aButtonApply");
                  }}
                />
              </div>
            }
          />
        </SnResizeBar>

        <SnResizeBar direction={"height"} id="panel2" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid2"]} // Grid Name
            columnConfig={grids.grid2.columns} // 컬럼 설정 전달
            rowData={grids.grid2.dataSource} // Datasource
            etcProps={{
              rowSelection: "multiple",
              title: "상세정보",
              ischeckboxSelection: true,
              extraHeaderMenuItems: [
                {
                  id: "extra_item_setting",
                  name: "부가항목설정",
                  visible: true,
                },
              ],
            }}
            header={
              <div>
                {isVisible && (
                  <SnButton
                    text={"품목병합"}
                    onClick={() => {
                      onGrid2BtnsClick("btnMerge");
                    }}
                  />
                )}
              </div>
            }
            events={grids.grid2.events}
          />
        </SnResizeBar>
        <SnFileUploadBox selectedDocu={selectedDocu} selectedLineDocu={0} />
      </div>
    </div>
  );
  //#endregion
});

export default SN_PRD_WMO_REG_003;
